const NPSheetType = Object.freeze({
  TEMPLATE: 'TEMPLATE',
  CUSTOM: 'CUSTOM'
})
export default NPSheetType
// RESERVE BELOW
